$(function (ws) {
    ws.views.simpleTooltip = Backbone.View.extend({

        /**
         * Open Tooltip
         * @param {string} text
         */
        setText (text) {
            this.$el.text(text);
            return this;
        },

        /**
         * Toggle Tooltip
         * @param {boolean} toggle
         * @returns {ws.simpleTooltip}
         */
        toggle (toggle) {
            this.$el.toggle(toggle);
            return this;
        },

        /**
         * Set Tooltip Position
         * @param {Object} el
         * @returns {ws.simpleTooltip}
         */
        position (el) {
            let position = el.getBoundingClientRect();
            this.$el.css({ top: position.top + (position.height / 2), left: position.left + el.offsetWidth + 5 }).show();

            return this;
        }

    });
}(westcon));
